import { Modal, Row, Col, Image } from 'react-bootstrap';
import ArticleLoginAndJoin  from './ArticleLoginAndJoin';

const ModalReadMore = (props) => {

    return (
        <Modal {...props} size="xl" aria-labelledby="modal" className="modal-read-more">
            <Modal.Header closeButton>
                <Modal.Title>Access FREE Wellness Resources!</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-3 pb-5">
                <Row>
                    <Col lg={6} className="text-center">
                        <h1>{props.article.title}</h1>
                        <p>Read this FREE article today!</p>
                        <Image src={props.article.featureImg ? props.article.featureImg : "https://via.placeholder.com/700x350.png?text=[img]"} alt="Article Image" className="img-fluid d-block mx-auto" />
                    </Col>
                    <Col lg={6}>
                        <ArticleLoginAndJoin props={props} />
                    </Col>
                </Row>
            </Modal.Body>
            
        <style jsx global>{`
            .modal-read-more .modal-title {
                font-size: 18px;
            }

            .modal-read-more .modal-body {
                font-size: 0.9rem;
            }

            .modal-read-more .modal-content .modal-header {
                color: #000;
            }

            .modal-read-more .modal-content .modal-header .close {
                font-size: 30px;
                opacity: 1;
                text-shadow: none;
                outline: 0;
            }

            .modal-read-more .modal-dialog{
                margin-top:150px;
            }

            .modal-read-more .player-wrapper {
                position: relative;
                padding-top: 56.25%;
            }

            .modal-read-more .react-player {
                position: absolute;
                top: 0;
                left: 0;
            }

            .modal-read-more h1{
                font-size: 1.5rem;
                font-weight:600;
            }
            `}</style>

        </Modal>
    );
};

export default ModalReadMore;